module.exports = __webpack_public_path__ + "img/喇叭.ff7504da.svg";